import { Link } from "react-router-dom";
import { SigWazLogo } from "../ui/SigWazLogo";
import { SunIcon, MoonIcon, BookIcon, ChevronDownIcon, ExternalLinkIcon } from "../ui/Icons";

const NAV_RESOURCES = [
  { name: "Sigma Rule Syntax",       desc: "Official rule specification",         domain: "sigmahq.io",                href: "https://sigmahq.io/docs/basics/rules.html" },
  { name: "SigmaHQ Rules Repository",desc: "3,000+ community detection rules",    domain: "github.com",                href: "https://github.com/SigmaHQ/sigma" },
  { name: "Sigma CLI",               desc: "Official Sigma conversion tool",       domain: "github.com",                href: "https://github.com/SigmaHQ/sigma-cli" },
  { name: "Wazuh Rules Docs",        desc: "XML ruleset syntax reference",         domain: "documentation.wazuh.com",   href: "https://documentation.wazuh.com/current/user-manual/ruleset/ruleset-xml-syntax/rules.html" },
  { name: "MITRE ATT&CK",            desc: "Adversary tactics & techniques",       domain: "attack.mitre.org",          href: "https://attack.mitre.org/" },
  { name: "ATT&CK Navigator",        desc: "Visualize technique coverage",         domain: "mitre-attack.github.io",    href: "https://mitre-attack.github.io/attack-navigator/" },
];

interface Props {
  isDark: boolean;
  onThemeToggle: () => void;
  onRefOpen: () => void;
}

export function Navbar({ isDark, onThemeToggle, onRefOpen }: Props) {
  return (
    <nav>
      <Link to="/" className="nav-logo-link" aria-label="Back to home">
        <SigWazLogo />
      </Link>
      <span className="nav-page">/ Converter</span>
      <span className="ver-chip">v1.0.0</span>
      <div className="nav-sp" />

      <div className="nav-res-dropdown">
        <button className="nav-res-trigger">
          Resources <ChevronDownIcon />
        </button>
        <div className="nav-res-panel">
          {NAV_RESOURCES.map((r) => (
            <a key={r.href} href={r.href} target="_blank" rel="noreferrer" className="nav-res-item">
              <img
                src={`https://www.google.com/s2/favicons?domain=${r.domain}&sz=16`}
                alt=""
                className="nav-res-favicon"
                width={16} height={16}
              />
              <div className="nav-res-info">
                <span className="nav-res-name">{r.name}</span>
                <span className="nav-res-desc">{r.desc}</span>
              </div>
              <ExternalLinkIcon />
            </a>
          ))}
        </div>
      </div>

      <button
        className="nav-icon-btn"
        onClick={onThemeToggle}
        title={isDark ? "Switch to light mode" : "Switch to dark mode"}
        aria-label={isDark ? "Switch to light mode" : "Switch to dark mode"}
      >
        {isDark ? <SunIcon /> : <MoonIcon />}
      </button>

      <button className="nav-ref-btn" onClick={onRefOpen} title="Sigma quick reference">
        <BookIcon />
        Reference
      </button>
    </nav>
  );
}
